// .html plugins are legacy standalone pages, loaded (and sandboxed) via iframe + postMessage.
// Anything else is a plugin bundle that registers a mount()/unmount() pair directly.
export function isHtmlPluginPath(path) {
    return path.toLowerCase().split(/[?#]/)[0].endsWith('.html');
}
const registry = new Map();
const waiters = new Map();
const loadedscripts = new Map();
// Keyed by the plugin bundle's own script URL rather than the (per-org) plugin
// database id, so the bundle doesn't need to know its id at build time - it
// registers itself using document.currentScript.src when it runs.
window.registerLetrPlugin = (scripturl, mod) => {
    registry.set(scripturl, mod);
    const ws = waiters.get(scripturl);
    if (ws) {
        ws.forEach((w) => w(mod));
        waiters.delete(scripturl);
    }
};
function loadScript(url) {
    let p = loadedscripts.get(url);
    if (p)
        return p;
    p = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = url;
        script.async = true;
        script.onload = () => resolve();
        script.onerror = () => {
            // don't leave a failed load cached forever - a fixed server/proxy
            // should be retried on the next call instead of replaying the same error.
            loadedscripts.delete(url);
            script.remove();
            reject(new Error(`Failed to load plugin script: ${url}`));
        };
        document.head.appendChild(script);
    });
    loadedscripts.set(url, p);
    return p;
}
// Contract for a plugin bundle hosted at `scripturl`: on load it must call
// window.registerLetrPlugin(document.currentScript.src, { mount(container, config), unmount?(container) })
export async function loadPlugin(scripturl, timeoutms = 15000) {
    const existing = registry.get(scripturl);
    if (existing)
        return existing;
    await loadScript(scripturl);
    const registered = registry.get(scripturl);
    if (registered)
        return registered;
    return new Promise((resolve, reject) => {
        var _a;
        const timer = setTimeout(() => {
            const ws = waiters.get(scripturl);
            if (ws) {
                waiters.set(scripturl, ws.filter((w) => w !== onregister));
            }
            reject(new Error(`Plugin at ${scripturl} did not call registerLetrPlugin within ${timeoutms}ms`));
        }, timeoutms);
        const onregister = (mod) => {
            clearTimeout(timer);
            resolve(mod);
        };
        const list = (_a = waiters.get(scripturl)) !== null && _a !== void 0 ? _a : [];
        list.push(onregister);
        waiters.set(scripturl, list);
    });
}
